export default "__VITE_ASSET__Rfxbfqlp__"